import { render, staticRenderFns } from "./user-grade-benefits.vue?vue&type=template&id=f58ef988&"
import script from "./user-grade-benefits.vue?vue&type=script&lang=js&"
export * from "./user-grade-benefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports